import React, { useEffect } from 'react'
import Header from '../../Header/Header'
import Nav from '../../Header/Nav'
import SousCategoryPage from './SousCategoriePage'
import Footer from '../../Footer/Footer'
import WhatssapIcon from '../../Home/WhatssapIcon'

const SousCategorie = () => {

  useEffect(() => {
    // This is more reliable for sticky headers
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth"
    });
}, []);


  return (
    <div>

        <Header />

        <Nav target="categorie" />

        <SousCategoryPage />

        <WhatssapIcon/>

        <Footer />



    </div>
  )
}

export default SousCategorie